import { string } from "prop-types";
import React, { useState, useRef, useEffect } from "react";

const ImageFilePreview = ({ image, ...props }) => {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (image && image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);

      reader.onload = function (e) {
        setPreview(e.target.result);
      };
      return
    } else if (image && image instanceof Blob) {
      const reader = new FileReader();
      reader.readAsText(image);

      reader.onload = function (e) {
        setPreview(e.target.result);
      };

      return
    }
    setPreview(image)
  }, [image])

  if (!preview) return;

  return (
      <img src={preview} alt="image" className="image-picker-image" {...props}/> 
  );
};

export default ImageFilePreview;